import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
};

const CalendarIcon = ({ color = '#fff', size = 15, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 13 13"
    width={size}
    {...props}
  >
    <path
      fill={color}
      d="M8.71 3.51c.269 0 .487-.218.487-.487V1.419a.488.488 0 0 0-.975 0v1.604c0 .269.219.487.487.487zm-5.243 0c.269 0 .487-.218.487-.487V1.419a.488.488 0 0 0-.975 0v1.604c0 .269.218.487.488.487zm8.06-1.387H9.781v.9a1.073 1.073 0 0 1-2.145 0v-.9H4.539v.9a1.073 1.073 0 0 1-2.145 0v-.9H.65a.65.65 0 0 0-.65.65v2.665h12.176V2.773a.65.65 0 0 0-.65-.65zM0 12.35c0 .359.291.65.65.65h10.876a.65.65 0 0 0 .65-.65V5.958H0v6.392zm8.998-4.848h1.664v1.663H8.998V7.502zm0 2.372h1.664v1.664H8.998V9.874zM6.504 7.502h1.663v1.663H6.504V7.502zm0 2.372h1.663v1.664H6.504V9.874zM4.01 7.502h1.663v1.663H4.01V7.502zm0 2.372h1.663v1.664H4.01V9.874zM1.515 7.502h1.663v1.663H1.515V7.502zm0 2.372h1.663v1.664H1.515V9.874z"
    />
  </svg>
);

CalendarIcon.propTypes = propTypes;

export default CalendarIcon;
